import {  all, takeEvery } from "redux-saga/effects"

export default function* root() {
  // all - effects will get executed in parallel

  console.log("Root Saga running")
    
  // fork - when we fork a task, the task is started in the background and the caller
  // can continue its flow without waiting for the forked task to terminate.
  yield all([
      takeEvery("App/DISCLAIMERRESET", nextOne),
    //   takeEvery("CCB/RESETSEARCH", anotherOne),      
    ]);
  

}


export  function* nextOne(){
    console.log("Next saga running")
    yield "hi"
    console.log("Next one saga running after hi")
    yield "again"
    console.log("Next one saga running after again")
}


export  function* anotherOne(){
    console.log("Another saga running")
    yield "hi2"
    console.log("Another saga running after hi2")
    yield "again2"
    console.log("Another saga running after again2")
}



